const PAGINATION_LABEL = {
  FINISHED_LOADING: 'All courses loaded',
  LOADING: 'Loading courses',
};

export default PAGINATION_LABEL;
